export default "/images/vendor/flag-icon-css/flags/1x1/sj.svg?7111b15215671c0cabae683635bd2bed";